import React, { useEffect, useState } from "react";
import { MainLayout } from "../../../layout/MainLayout";
import ReactPlayer from "react-player";
import { Button } from "../../../components/client/Button/Button";
import Description from "./Description";
import { HOST } from "../../../config";
import { sampleSize } from "lodash";
import ReactLoading from "react-loading";
import ResultModal from "./ResultModal";
import ImageModal from "./ImageModal";

export default function SimulationExam() {
  const [dataSimu, setDataSimu] = useState([]);
  const [data, setData] = useState([]);
  const [current, setCurrent] = useState(0);
  const [currentExam, setCurrentExam] = useState(0);
  const [duration, setDuration] = useState(0);
  const [currentDataSimu, setcurrentDataSimu] = useState(0);
  const [time, setTime] = useState([]);
  const [pointNow, setPointNow] = useState(0);
  const [bo, setBo] = useState([]);
  const [point, setPoint] = useState([]);
  const [isResult, setIsResult] = useState(false);
  const [showImage, setShowImage] = useState(false);
  const [urlResult, setUrlResult] = useState(false);
  const [start, setStart] = useState(false);
  const [isShowResult, setIsShowResult] = useState(true);
  const [resultData, setResultData] = useState({});
  
  useEffect(() => {
    const requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    fetch(`${HOST}/simulation/exam/all/client`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        const res = JSON.parse(result);
        const requestOptions = {
          method: "GET",
          redirect: "follow",
        };

        fetch(`${HOST}/simulation/all/client`, requestOptions)
          .then((response2) => response2.text())
          .then((result2) => {
            const res2 = JSON.parse(result2);
            const examRandome = sampleSize(res2, 10);
            const randomeId = examRandome.map((v) => v.id);
            const randomeobk = {
              id: -10,
              name: "Ngẫu nhiên",
              simulation: randomeId,
            };
            const resParse = res.map((v) => {
              v.simulation = JSON.parse(v.simulation);
              return v;
            });
            const data = [randomeobk, ...resParse];

            const simuId = data[0]?.simulation[0];
            const getDataSimu = res2.filter((v) => v.id === simuId);
            setcurrentDataSimu(getDataSimu[0]);

            setData(data);
            setCurrent(data[0]);
            setDataSimu(res2);
          })
          .catch((error) => console.log("error", error));
      })
      .catch((error) => console.log("error", error));
  }, []);

  useEffect(() => {
    document.addEventListener(
      "keydown",
      (e) => {
        if (e.code === "Space") {
          e.preventDefault();
          checkPoint();
        }
      },
      true
    );
  });

  function startExam() {
    setStart(true)
  }

  function getDuration({ playedSeconds }) {
    setDuration(Math.floor(playedSeconds));
  }

  function handlePick(i) {
    setCurrent(data[i]);
  }

  function checkPoint() {
    const data = time.filter((v) => v.id === currentExam).length;
    console.log(data);
    if (current && !data) {
      const point = currentDataSimu.point;
      const getPoint = point.split(",").map((v) => {
        const item = v.trim();
        const value = item.split(":");
        return {
          duration: Number(value[0]),
          point: Number(value[1]),
        };
      });
      const getDuration = duration;
      for (const item of getPoint) {
        const durationDB = item.duration;
        const point = item.point;
        if (getDuration === durationDB) {
          setPointNow(point);
        }
      }
      setTime([
        ...time,
        {
          id: currentExam,
          time: getDuration,
        },
      ]);
    }
  }

  function nextVideo() {
    const total = current?.simulation?.length;
    if (currentExam === total - 1) {
      
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      const total = point.reduce((prev, current) => prev + current, 0);
      const data = {
        examNo: current.name,
        examCount: current?.simulation?.length,
        pointExam: total,
        date: new Date().toISOString(),
        result: total >= 35 ? 'Đạt' : 'Không đạt',
        point
      }
      const raw = JSON.stringify({
        type: 'simulation',
        value: JSON.stringify(data)
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(`${HOST}/resource/result`, requestOptions)
        .then((response) => response.text())
        .then((result) => {
          const res = JSON.parse(result);
          const id = res.id;
          setUrlResult(`${HOST}/resource/result/simulation-result/` + id)
          setIsResult(true);
          setPoint([...point, pointNow]);
          setResultData(data);
        })
        .catch((error) => console.log("error", error));
    } else {
      const simuId = data[0]?.simulation[currentExam + 1];
      const getDataSimu = dataSimu.filter((v) => v.id === simuId);
      setcurrentDataSimu(getDataSimu[0]);
      setCurrentExam(currentExam + 1);
      setPoint([...point, pointNow]);
      if (!pointNow) {
        setBo([...bo, currentExam]);
      }
      setPointNow(0);
    }
  }

  function flagStatus(i) {
    if (isResult) {
      return <span>{point[i]}</span>;
    } else {
      if (time.filter((v) => v.id === i).length) {
        const timeData = time.filter((v) => v.id === i)[0].time;
        if (timeData < 10) {
          return <span>00:0{timeData}</span>;
        }

        if (timeData >= 10 && timeData < 60) {
          return <span>00:{timeData}</span>;
        }
      } else if (currentExam === i) {
        return (
          <ReactLoading type="bubbles" color="green" height={32} width={32} />
        );
      } else if (bo.includes(i)) {
        return <span>Bỏ</span>;
      }
    }
  }

  function checkReview() {
    if (!isResult) {
      return <span>Đang thi</span>;
    }
    const total = point.reduce((prev, current) => prev + current, 0);
    if (total >= 35) {
      return <span>Đạt</span>;
    } else {
      return <span>Không Đạt</span>;
    }
  }

  function checkTotalPoint() {
    if (!isResult) {
      return <span>---</span>;
    }
    const total = point.reduce((prev, current) => prev + current, 0);
    return `${total}/50`;
  }

  return (
    <MainLayout>
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-2">
        <div>
          <div className="border-2">
            <div className="bg-[#a0214e] p-2">
              <p className="text-white font-bold">Thông tin học viên :</p>
            </div>

            <div className="p-2">
              <p>- Loại GPLX : B11</p>
              <p>- Họ và Tên : Nguyễn A</p>
              <p>- CCCD : 123456789</p>
              <p>- SBD : 53453453</p>
            </div>
          </div>

          <div className="border-2 my-2">
            <div className="bg-[#a0214e] p-2">
              <p className="text-white font-bold">Thông Tin bài thi :</p>
            </div>
            <div className="p-2">
              <p>
                - Đề thi gồm 10 câu. Mỗi câu được tối đa 5 điểm và tối thiểu 0
                điểm.
              </p>
              <p>- Kết quả Đạt: khi đạt tổng điểm {">"}= 35 điểm .</p>
              <p>
                - Các tình huống sẽ tự động chuyển. Ấn F11 để xem toàn màn hình.
              </p>
              <p>- Xem 120 tình huống [Xem]</p>
            </div>
          </div>
          <Button
            isDisabled={start}
            onClick={startExam}
            className={`w-full text-white ${start ? 'bg-green-800' : 'bg-green-600'}`}
          >
            Bắt đầu thi
          </Button>
        </div>
        <div className="col-span-2">
          <ReactPlayer
            muted={true}
            controls={false}
            width="100%"
            height="auto"
            playing={start}
            onEnded={nextVideo}
            onProgress={getDuration}
            url={currentDataSimu.video}
          />
          <div className="grid border-2 p-2 grid-cols-1 lg:grid-cols-3">
            <p className="col-span-2">
              Tình huống 1: Học viên nhấn phím space trên bàn phím khi phát hiện
              tình huống nguy hiểm.
            </p>
            <div>
              <Button
                onClick={() => setShowImage(!showImage)}
                className="bg-[#a0214e]"
              >
                Hiện gợi ý
              </Button>
            </div>
          </div>
          <Button onClick={checkPoint} className="w-full text-white">
            Tính điểm
          </Button>
        </div>
        <div>
          <div className="border-2">
            <div className="bg-[#a0214e] p-2">
              <p className="text-white font-bold">Kết quả</p>
            </div>
            <div className="p-2">
              <p>Số tình huống: {current?.simulation?.length}</p>
              <p>Điểm: {checkTotalPoint()}</p>
              <p>Đánh giá: {checkReview()}</p>
              {isResult && <Button
                onClick={() => setIsShowResult(true)}
                className={`w-full text-white ${start ? 'bg-green-800' : 'bg-green-600'}`}
              >
                Xem lại kết quả
              </Button>}
            </div>
          </div>
          <div className="border-2 p-2">
            <table className="table-auto border-collapse border border-slate-400 w-full">
              <thead>
                <tr>
                  <th className="border border-slate-300">Câu hỏi</th>
                  <th className="border border-slate-300">Gắn cờ</th>
                </tr>
              </thead>
              <tbody>
                {current?.simulation?.map((item, i) => {
                  return (
                    <tr key={i}>
                      <td className="border border-slate-300">
                        Câu hỏi {i + 1} :
                      </td>
                      <td className="border border-slate-300">
                        {flagStatus(i)}
                      </td>
                    </tr>
                  );
                })}
                <tr>
                  <td>Đang thi Số {current.name}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="border-2 my-2 p-2">
            <p className="p-1">Chọn dạng đề thi :</p>
            <div>
              {data.map((item, i) => {
                return current.id === item.id ? (
                  <Button
                    key={i}
                    onClick={() => handlePick(i)}
                    className="mr-2 mb-2 min-w-[40px] text-white font-bold"
                  >
                    {item.name}
                  </Button>
                ) : (
                  <Button
                    onClick={() => handlePick(i)}
                    key={i}
                    className="mr-2 mb-2 min-w-[40px] bg-[#eeeeee] text-black font-bold"
                  >
                    {item.name}
                  </Button>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <Description />
      {(isResult && isShowResult) && ResultModal(urlResult, point, resultData, setIsShowResult)}
      {showImage &&
        ImageModal(currentDataSimu.name, currentDataSimu.image, setShowImage)}
    </MainLayout>
  );
}
